import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AccountPage } from '~/components/account-page'
import { PageHeader } from '~/components/app-shell'
import { ProfileCard } from '~/components/profile-card'
import { SettingsNav } from '~/components/settings-nav'

export const Route = createFileRoute('/_authed/app/settings/account')({
  validateSearch: z.object({ token: z.string().max(100).optional().catch(undefined) }),
  head: () => ({ meta: [{ title: `${m.account_title()} - ${m.app_name()}` }] }),
  component: AccountRoute,
})

function AccountRoute() {
  const { token } = Route.useSearch()
  return (
    <>
      <SettingsNav />
      <PageHeader title={m.account_title()} description={m.account_description()} />
      <div className="max-w-2xl space-y-6">
        <ProfileCard />
        <AccountPage token={token} />
      </div>
    </>
  )
}
